import { render, staticRenderFns } from "./prepareLessonCenter.vue?vue&type=template&id=67619e8c&scoped=true"
import script from "./prepareLessonCenter.vue?vue&type=script&lang=js"
export * from "./prepareLessonCenter.vue?vue&type=script&lang=js"
import style0 from "./prepareLessonCenter.vue?vue&type=style&index=0&id=67619e8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67619e8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67619e8c')) {
      api.createRecord('67619e8c', component.options)
    } else {
      api.reload('67619e8c', component.options)
    }
    module.hot.accept("./prepareLessonCenter.vue?vue&type=template&id=67619e8c&scoped=true", function () {
      api.rerender('67619e8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prepareLesson/prepareLessonCenter.vue"
export default component.exports